import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EduIDButton } from "components/Common/EduIDButton";
import { EmailInput } from "components/Common/EmailInput";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { Form as FinalForm } from "react-final-form";
import { FormattedMessage } from "react-intl";
import resetPasswordSlice from "slices/ResetPassword";
export function EmailForm({ passEmailUp, disabled, defaultEmail }) {
    const dispatch = useAppDispatch();
    const dashboard_link = useAppSelector((state) => state.config.dashboard_link);
    const submitEmailForm = (values) => {
        const errors = {};
        if (values.email) {
            passEmailUp(values.email);
        }
        else {
            errors.email = "required";
        }
        return errors;
    };
    const handleCancel = () => {
        if (dashboard_link) {
            document.location.href = dashboard_link;
        }
        dispatch(resetPasswordSlice.actions.resetEmailStatus());
    };
    return (_jsx(FinalForm, { onSubmit: submitEmailForm, render: (formProps) => {
            var _a;
            const _submitError = Boolean(formProps.submitError && !formProps.dirtySinceLastSubmit);
            const _disabled = Boolean(formProps.hasValidationErrors ||
                _submitError ||
                formProps.pristine ||
                disabled ||
                !((_a = formProps.values) === null || _a === void 0 ? void 0 : _a["email"]));
            return (_jsxs("form", { id: "reset-password-form", onSubmit: formProps.handleSubmit, children: [_jsx(EmailInput, { name: "email", autoFocus: true, required: true, autoComplete: "username", defaultValue: defaultEmail }), _jsxs("div", { className: "buttons", children: [_jsx(EduIDButton, { id: "cancel-button", buttonstyle: "secondary", onClick: handleCancel, children: _jsx(FormattedMessage, { id: "common.cancel", defaultMessage: "Cancel", description: "button cancel" }) }), _jsx(EduIDButton, { buttonstyle: "primary", id: "reset-password-button", disabled: _disabled, type: "submit", onClick: formProps.handleSubmit, children: _jsx(FormattedMessage, { id: "resetPassword.emailForm.button", defaultMessage: "send email", description: "Reset Password button" }) })] })] }));
        } }));
}
